import { Destroyed } from '../types/EntryTypes/Destroyed';
import { CardDivider, DateFormat, NumberFormat, Tag, ValuesList, ValuesListItem } from '@crx-dev/hss-react-components';
import React from 'react';

interface DestroyedInfoProps {
    item: Destroyed;
    columns: number;
}

function DestroyedInfo({ item, columns }: DestroyedInfoProps) {
    return (
        <>
            <ValuesList columns={columns}>
                <ValuesListItem label="Type">
                    <Tag color="BeakerPink">Destroyed</Tag>
                </ValuesListItem>
                <ValuesListItem label="Date">
                    <DateFormat date={item.createdDateTime} format="date" />
                </ValuesListItem>
                <ValuesListItem label="Quantity Destroyed" color="BeakerPink">
                    <NumberFormat value={item.quantity} />
                </ValuesListItem>
                <ValuesListItem label="Total Balance" bold>
                    <NumberFormat value={item.balance} />
                </ValuesListItem>
            </ValuesList>

            <CardDivider />

            <ValuesList columns={columns}>
                <ValuesListItem label="Destroyed By">
                    {item.destroyedBy.name}, {item.destroyedBy.role}, {item.destroyedBy.professionalRegistrationNumber}
                </ValuesListItem>
                <ValuesListItem label="Witnessed By">
                    {item.witnessedBy.name}, {item.witnessedBy.role}, {item.witnessedBy.professionalRegistrationNumber}
                </ValuesListItem>
                <ValuesListItem label="Authority Number">{item.authorityNumber}</ValuesListItem>
                <ValuesListItem label="Added By">{item.addedBy || item.user}</ValuesListItem>
            </ValuesList>
        </>
    );
}

export default DestroyedInfo;
